import {Component, ContentChild  } from '@angular/core'
 
@Component({ selector: 'show-hide-container',
 template: `<ng-content></ng-content>
            <a (click)="toggleShow()" class="pull-right"><i class="fa" [ngClass]="{'fa-eye-slash': !isHidden, 'fa-eye': isHidden}"></i></a>`
})
export class ShowHideContainer
{
   show = false;
   public isHidden: boolean = false;
 
   @ContentChild('showhideinput') input;
 
   constructor(){}
 
   toggleShow()
   {
      this.show = !this.show;
     // console.log(this.input);
      if (this.show){
         this.input.nativeElement.type='text';
         this.isHidden = false;
      }
      else {
         this.input.nativeElement.type='password';
         this.isHidden = true;
      }
   }
}


// WEBPACK FOOTER //
// ./src/app/login/show-hide-container.ts